export const normalizeForUrl = text => text.normalize("NFD")
                                        .replace(/[\u0300-\u036f]/g, "")
                                        .replace(/-|\?|,/g, '')
                                        .replace(/ +/g, '-')
                                        .toLowerCase()
                                        .trim();
